import { render, staticRenderFns } from "./EditPolizaDataCard.vue?vue&type=template&id=6ea8a7ac&scoped=true"
import script from "./EditPolizaDataCard.vue?vue&type=script&lang=js"
export * from "./EditPolizaDataCard.vue?vue&type=script&lang=js"
import style0 from "./EditPolizaDataCard.vue?vue&type=style&index=0&id=6ea8a7ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea8a7ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanelContent})
